export default "__VITE_ASSET__CdPpkMUo__"